/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Pain_Pick_RegionInputs */

const en_us2_onboarding_pain_pick_region = /** @type {(inputs: Onboarding_Pain_Pick_RegionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark at least one spot, or go back and answer that nothing hurts.`)
};

const pt_br2_onboarding_pain_pick_region = /** @type {(inputs: Onboarding_Pain_Pick_RegionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marque pelo menos um ponto, ou volte e responda que nada dói.`)
};

const es_419_onboarding_pain_pick_region = /** @type {(inputs: Onboarding_Pain_Pick_RegionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marca al menos un punto, o vuelve y responde que nada te duele.`)
};

const pt_pt2_onboarding_pain_pick_region = /** @type {(inputs: Onboarding_Pain_Pick_RegionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marca pelo menos um ponto, ou volta atrás e responde que nada dói.`)
};

const fr_fr2_onboarding_pain_pick_region = /** @type {(inputs: Onboarding_Pain_Pick_RegionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indique au moins une zone, ou reviens en arrière et réponds que rien ne te fait mal.`)
};

const de_de2_onboarding_pain_pick_region = /** @type {(inputs: Onboarding_Pain_Pick_RegionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Markiere mindestens eine Stelle, oder geh zurück und antworte, dass nichts wehtut.`)
};

const it_it2_onboarding_pain_pick_region = /** @type {(inputs: Onboarding_Pain_Pick_RegionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Segna almeno un punto, oppure torna indietro e rispondi che non ti fa male niente.`)
};

/**
* | output |
* | --- |
* | "Mark at least one spot, or go back and answer that nothing hurts." |
*
* @param {Onboarding_Pain_Pick_RegionInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const onboarding_pain_pick_region = /** @type {((inputs?: Onboarding_Pain_Pick_RegionInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Pain_Pick_RegionInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_onboarding_pain_pick_region(inputs)
	if (locale === "es-419") return es_419_onboarding_pain_pick_region(inputs)
	if (locale === "pt-PT") return pt_pt2_onboarding_pain_pick_region(inputs)
	if (locale === "fr-FR") return fr_fr2_onboarding_pain_pick_region(inputs)
	if (locale === "de-DE") return de_de2_onboarding_pain_pick_region(inputs)
	if (locale === "it-IT") return it_it2_onboarding_pain_pick_region(inputs)
	return en_us2_onboarding_pain_pick_region(inputs)
});
export { onboarding_pain_pick_region as "onboarding.pain_pick_region" }